import {
  ProductDetailsIngredientContainer,
  ProductDetailsIngredientContentContainer,
  ProductDetailsIngredientHighlights,
  ProductDetailsIngredientImage,
  ProductDetailsIngredientTitle,
} from './components';

export const ProductDetailsIngredient = {
  Container: ProductDetailsIngredientContainer,
  ContentContainer: ProductDetailsIngredientContentContainer,
  Image: ProductDetailsIngredientImage,
  Title: ProductDetailsIngredientTitle,
  Highlights: ProductDetailsIngredientHighlights,
};
